__turbopack_context__.v({
  "featureIcon": "ArtCWG_featureIcon",
  "heading": "ArtCWG_heading",
  "img__h1Ewd": "ArtCWG_img__h1Ewd",
  "text1": "ArtCWG_text1",
  "textContainer": "ArtCWG_textContainer",
  "textWithIcon": "ArtCWG_textWithIcon",
});
